<template>
    <div class="special-container" :class="{fadeInUp: turnOnFade}" >
        <div class="special" :class="{hide: hide}">
            <wp-image :image="image"
                      class="image-container"
                      :is-background="true"
                      :size-hd="`special-hd`"
                      :load-immediate="true"
                      @loaded="showSpecial"
            ></wp-image>
            <div class="content-container">
                <content-block :body="body"
                               :button="button"
                               :section_heading="title"
                ></content-block>
                <div class="close-icon" @click="hideSpecial">
                    <font-awesome-icon :icon="closeIcon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentBlock from './ContentBlock'
    import { faTimes }  from '@fortawesome/pro-light-svg-icons/faTimes'

    export default {
        name: "Special",
        components: { ContentBlock },
        props: {
            body: String,
            button: Object,
            image: Object,
            title: String
        },
        data() {
            return {
                hide: true,
                turnOnFade: false
            }
        },
        mounted() {
            setTimeout(() => {
                this.hide = false;
                this.turnOnFade = true;
            }, 800);
        },
        computed: {
            closeIcon() {
                return faTimes
            }
        },
        methods: {
            showSpecial() {
                console.log('image ready')
            },
            hideSpecial() {
                this.hide = true
            }
        }
    }
</script>

<style lang="scss" scoped>

    .special-container {
        position: relative;
        width: 100%;
        height: 100%;
        @include site-container;
    }

    .fadeInUp {
        animation-duration: 1s;
        animation-fill-mode: both;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        opacity: 0;
        -webkit-animation-name: fadeInUp;
        animation-name: fadeInUp;
    }


    @-webkit-keyframes fadeInUp {
        from {
            transform: translate3d(0,40px,0)
        }
        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }

    @keyframes fadeInUp {
        from {
            transform: translate3d(0,40px,0)
        }

        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }

    .special {
        display: flex;
        height: min-content;
        background: $white;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.22);
        opacity: 1;
        transition: all 300ms;
        position: absolute;
        right: 0;
        width: 60%;
        max-width: 800px;
        transform: matrix(1, 0, 0, 1, 0, -310);

        @media (max-width: $bp-small) {
            width: 100%;
            transform: matrix(1, 0, 0, 1, 0, -350);
        }

        @media (max-width: 500px) {
            background-position: right;
            transform: matrix(1, 0, 0, 1, 0, -490);
        }

        @media (min-width: $bp-desktop) {
            right: 40px;
        }
    }

    .image-container {
        background: no-repeat center;
        background-size: cover;
        width: 30%;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.22);

        @media (max-width: 500px) {
            background-position: right;
        }
    }

    .content-container {
        width: 70%;
        padding: 75px 50px;
        display: flex;
        align-items: center;

        @media (min-width: $bp-desktop) {
            padding: 75px 105px 75px 75px;
        }

        /deep/ .content-block {
            padding: 0;

            > .block {
                padding: 0;
            }

            .button {
                margin-top: 25px;
            }
        }
    }

    .close-icon {
        color: #D7D8DF;
        font-size: 30px;
        position: absolute;
        top: 25px;
        right: 30px;

        &:hover {
            cursor: pointer;
            color: $theme-orange;
        }
    }

    .hide {
        opacity: 0;
        pointer-events: none;
    }

</style>